// src/App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import TestingPage from './components/TestingPage';
import './App.css';

function UrlInputPage() {
    const [url, setUrl] = useState('');
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        if (url.trim()) {
            // Basic URL validation (can be improved)
            if (!url.startsWith('http://') && !url.startsWith('https://')) {
                alert('Please enter a valid URL starting with http:// or https://');
                return;
            }
            // Encode the URL to safely pass it as a parameter
            navigate(`/test/${encodeURIComponent(url)}`);
        }
    };

    return (
        <div className="url-input-page">
            <h1>QA Test Automator</h1>
            <p>Enter the URL of the website you want to test:</p>
            <form onSubmit={handleSubmit}>
                <input
                    type="url"
                    placeholder="https://example.com"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                    required
                />
                <button type="submit">Start Testing</button>
            </form>
        </div>
    );
}


function App() {
    return (
        <Router>
            <div className="app-container">
                <Routes>
                    <Route path="/" element={<UrlInputPage />} />
                    <Route path="/test/:encodedUrl" element={<TestingPage />} />
                    {/* Add other routes if needed */}
                </Routes>
            </div>
        </Router>
    );
}

export default App;
